module.exports = __webpack_public_path__ + "static/eulogo-fa8ce6f1bea6fb931f961a0e80c66699.png";